/* eslint-disable */
import { createAction, createReducer } from 'utils/reducer/utils.reducer';
import moment from 'moment';
import {
  HIDE_BULK_REFUND_MODAL,
  SHOW_BULK_REFUND_MODAL,
  TOGGLE_BULK_REFUND_MODAL,
} from '../../Guarantees/reducer/guarantees.reducer';

const PATH = 'guaranteesUnification/';
const TOGGLE_DETAILS = `${PATH}TOGGLE_DETAILS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const APPLY_FILTER = `${PATH}APPLY_FILTER`;
const CLEAR_FILTER = `${PATH}CLEAR_FILTER`;
const CONTROLS_CHANGED = `${PATH}CONTROLS_CHANGED`;
const PAYMENT_CONTROLS_CHANGED = `${PATH}PAYMENT_CONTROLS_CHANGED`;
const FILTERS_CHANGED = `${PATH}FILTERS_CHANGED`;
const SET_IDS = `${PATH}SET_IDS`;
const PAGINATION_CHANGED = `${PATH}PAGINATION_CHANGED`;
const SET_EXPANDED_USER_ID = `${PATH}SET_EXPANDED_USER_ID`;
const SHOW_GUARANTEE_SELECTION = `${PATH}SHOW_GUARANTEE_SELECTION`;
const SET_GUARANTEE = `${PATH}SET_GUARANTEE`;
const TOGGLE_LETTER = `${PATH}TOGGLE_LETTER`;

export const GUARANTEES_UNIFICATION = {
  //gest state
  RESET: `${PATH}RESET`,
  INITIAL_QUERY: `${PATH}INITIAL_QUERY`,
  INITIAL_QUERY_SUCCESS: `${PATH}INITIAL_QUERY_SUCCESS`,
  INITIAL_QUERY_FAIL: `${PATH}INITIAL_QUERY_FAIL`,
  ACKNOWLEDGE_REFUND: `${PATH}ACKNOWLEDGE_REFUND`,
  ACKNOWLEDGE_REFUND_SUCCESS: `${PATH}ACKNOWLEDGE_REFUND_SUCCESS`,
  ACKNOWLEDGE_REFUND_FAIL: `${PATH}ACKNOWLEDGE_REFUND_FAIL`,
  CHANGE_AMOUNT: `${PATH}CHANGE_AMOUNT`,
  CHANGE_AMOUNT_SUCCESS: `${PATH}CHANGE_AMOUNT_SUCCESS`,
  CHANGE_AMOUNT_FAIL: `${PATH}CHANGE_AMOUNT_FAIL`,
  SET_FLAG: `${PATH}SET_FLAG`,
  SET_FLAG_SUCCESS: `${PATH}SET_FLAG_SUCCESS`,
  SET_FLAG_FAIL: `${PATH}SET_FLAG_FAIL`,
  UNSET_FLAG: `${PATH}UNSET_FLAG`,
  UNSET_FLAG_SUCCESS: `${PATH}UNSET_FLAG_SUCCESS`,
  UNSET_FLAG_FAIL: `${PATH}UNSET_FLAG_FAIL`,
  GET_REPORT: `${PATH}GET_REPORT`,
  ACCEPT_RECEIPT: `${PATH}ACCEPT_RECEIPT`,
  ACCEPT_RECEIPT_SUCCESS: `${PATH}ACCEPT_RECEIPT_SUCCESS`,
  ACCEPT_RECEIPT_FAIL: `${PATH}ACCEPT_RECEIPT_FAIL`,
  REJECT_RECEIPT: `${PATH}REJECT_RECEIPT`,
  REJECT_RECEIPT_SUCCESS: `${PATH}REJECT_RECEIPT_SUCCESS`,
  REJECT_RECEIPT_FAIL: `${PATH}REJECT_RECEIPT_FAIL`,
  EDIT_AMOUNT: `${PATH}EDIT_AMOUNT`,
  EDIT_AMOUNT_SUCCESS: `${PATH}EDIT_AMOUNT_SUCCESS`,
  EDIT_AMOUNT_FAIL: `${PATH}EDIT_AMOUNT_FAIL`,
  RETRY_PAYMENT: `${PATH}RETRY_PAYMENT`,
  RETRY_PAYMENT_SUCCESS: `${PATH}RETRY_PAYMENT_SUCCESS`,
  RETRY_PAYMENT_FAIL: `${PATH}RETRY_PAYMENT_FAIL`,
  UNDO_PAYMENT: `${PATH}UNDO_PAYMENT`,
  UNDO_PAYMENT_SUCCESS: `${PATH}UNDO_PAYMENT_SUCCESS`,
  UNDO_PAYMENT_FAIL: `${PATH}UNDO_PAYMENT_FAIL`,
  DO_NOTHING: `${PATH}DO_NOTHING`,
  ENABLE_PAYMENT: `${PATH}ENABLE_PAYMENT`,
  ENABLE_PAYMENT_SUCCESS: `${PATH}ENABLE_PAYMENT_SUCCESS`,
  ENABLE_PAYMENT_FAIL: `${PATH}ENABLE_PAYMENT_FAIL`,
  DISABLE_PAYMENT: `${PATH}DISABLE_PAYMENT`,
  DISABLE_PAYMENT_SUCCESS: `${PATH}DISABLE_PAYMENT_SUCCESS`,
  DISABLE_PAYMENT_FAIL: `${PATH}DISABLE_PAYMENT_FAIL`,
  REJECT_PAYMENT: `${PATH}REJECT_PAYMENT`,
  REJECT_PAYMENT_SUCCESS: `${PATH}REJECT_PAYMENT_SUCCESS`,
  REJECT_PAYMENT_FAIL: `${PATH}REJECT_PAYMENT_FAIL`,
};

// actions
export const guaranteesActions = {
  reset: createAction(GUARANTEES_UNIFICATION.RESET),
  toggleDetails: createAction(TOGGLE_DETAILS, 'guarantee'),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  applyFilter: createAction(APPLY_FILTER),
  clearFilter: createAction(CLEAR_FILTER),
  controlsChanged: createAction(CONTROLS_CHANGED, 'controls', 'invalidControls'),
  filtersChanged: createAction(FILTERS_CHANGED, 'filters'),
  setIds: createAction(SET_IDS, 'ids'),
  paginationChanged: createAction(PAGINATION_CHANGED, 'options'),
  setExpandedUserId: createAction(SET_EXPANDED_USER_ID, 'id'),
  toggleLetter: createAction(TOGGLE_LETTER),
  // API
  initialQuery: createAction(GUARANTEES_UNIFICATION.INITIAL_QUERY, 'filters', 'pagination'),
  initialQuerySuccess: createAction(GUARANTEES_UNIFICATION.INITIAL_QUERY_SUCCESS, 'payload'),
  initialQueryFail: createAction(GUARANTEES_UNIFICATION.INITIAL_QUERY_FAIL, 'payload'),
  acknowledgeRefund: createAction(GUARANTEES_UNIFICATION.ACKNOWLEDGE_REFUND, 'id', 'undo'),
  acknowledgeRefundSuccess: createAction(
    GUARANTEES_UNIFICATION.ACKNOWLEDGE_REFUND_SUCCESS,
    'payload',
  ),
  acknowledgeRefundFail: createAction(GUARANTEES_UNIFICATION.ACKNOWLEDGE_REFUND_FAIL, 'payload'),
  changeAmount: createAction(GUARANTEES_UNIFICATION.CHANGE_AMOUNT, 'id', 'amount'),
  changeAmountSuccess: createAction(GUARANTEES_UNIFICATION.CHANGE_AMOUNT_SUCCESS, 'payload'),
  changeAmountFail: createAction(GUARANTEES_UNIFICATION.CHANGE_AMOUNT_FAIL, 'payload'),
  setFlag: createAction(GUARANTEES_UNIFICATION.SET_FLAG, 'id', 'syncFlag'),
  setFlagSuccess: createAction(GUARANTEES_UNIFICATION.SET_FLAG_SUCCESS, 'payload'),
  setFlagFail: createAction(GUARANTEES_UNIFICATION.SET_FLAG_FAIL, 'payload'),
  unsetFlag: createAction(GUARANTEES_UNIFICATION.UNSET_FLAG, 'id'),
  unsetFlagSuccess: createAction(GUARANTEES_UNIFICATION.UNSET_FLAG_SUCCESS, 'payload'),
  unsetFlagFail: createAction(GUARANTEES_UNIFICATION.UNSET_FLAG_FAIL, 'payload'),
  getReport: createAction(GUARANTEES_UNIFICATION.GET_REPORT, 'payload'),
  // Bulk refund
  showBulkRefundModal: createAction(SHOW_BULK_REFUND_MODAL),
  hideBulkRefundModal: createAction(HIDE_BULK_REFUND_MODAL),
  toggleBulkRefundModal: createAction(TOGGLE_BULK_REFUND_MODAL),
  paymentControlsChanged: createAction(PAYMENT_CONTROLS_CHANGED, 'controls', 'invalidControls'),
  acceptReceipt: createAction(GUARANTEES_UNIFICATION.ACCEPT_RECEIPT, 'paymentId'),
  rejectReceipt: createAction(GUARANTEES_UNIFICATION.REJECT_RECEIPT, 'paymentId', 'notes'),
  editAmount: createAction(GUARANTEES_UNIFICATION.EDIT_AMOUNT, 'paymentId', 'amount'),
  retryPayment: createAction(GUARANTEES_UNIFICATION.RETRY_PAYMENT, 'id', 'guaranteeId'),
  undoPayment: createAction(GUARANTEES_UNIFICATION.UNDO_PAYMENT, 'id'),
  enablePayment: createAction(GUARANTEES_UNIFICATION.ENABLE_PAYMENT, 'id'),
  disablePayment: createAction(GUARANTEES_UNIFICATION.DISABLE_PAYMENT, 'id'),
  rejectPayment: createAction(GUARANTEES_UNIFICATION.REJECT_PAYMENT, 'id'),
  // success
  acceptReceiptSuccess: createAction(GUARANTEES_UNIFICATION.ACCEPT_RECEIPT_SUCCESS, 'payload'),
  rejectReceiptSuccess: createAction(GUARANTEES_UNIFICATION.REJECT_RECEIPT_SUCCESS, 'payload'),
  editAmountSuccess: createAction(GUARANTEES_UNIFICATION.EDIT_AMOUNT_SUCCESS, 'payload'),
  retryPaymentSuccess: createAction(GUARANTEES_UNIFICATION.RETRY_PAYMENT_SUCCESS, 'payload'),
  undoPaymentSuccess: createAction(GUARANTEES_UNIFICATION.UNDO_PAYMENT_SUCCESS, 'payload'),
  enablePaymentSuccess: createAction(GUARANTEES_UNIFICATION.ENABLE_PAYMENT_SUCCESS, 'payload'),
  disablePaymentSuccess: createAction(GUARANTEES_UNIFICATION.DISABLE_PAYMENT_SUCCESS, 'payload'),
  // fail
  acceptReceiptFail: createAction(GUARANTEES_UNIFICATION.ACCEPT_RECEIPT_SUCCESS, 'payload'),
  rejectReceiptFail: createAction(GUARANTEES_UNIFICATION.REJECT_RECEIPT_SUCCESS, 'payload'),
  editAmountFail: createAction(GUARANTEES_UNIFICATION.EDIT_AMOUNT_FAIL, 'payload'),
  retryPaymentFail: createAction(GUARANTEES_UNIFICATION.RETRY_PAYMENT_FAIL, 'payload'),
  undoPaymentFail: createAction(GUARANTEES_UNIFICATION.UNDO_PAYMENT_FAIL, 'payload'),
  enablePaymentFail: createAction(GUARANTEES_UNIFICATION.ENABLE_PAYMENT_FAIL, 'payload'),
  disablePaymentFail: createAction(GUARANTEES_UNIFICATION.DISABLE_PAYMENT_FAIL, 'payload'),

  doNothing: createAction(GUARANTEES_UNIFICATION.DO_NOTHING, 'payload'),
};

const defaultControls = {
  receiptAmount: null,
  observations: null,
};

const defaultInvalidControls = {
  receiptAmount: false,
};

const tomorrow = moment().add(1, 'day').startOf('day');

const defaultPaymentControls = {
  paymentGuaranteeId: null,
  receiptAmount: null,
  observations: '',
};

const initialState = {
  controls: {
    doQuery: true,
    expandedUserId: null,
    groupByUser: false,
    showDetails: false,
    anchorEl: null,
    guaranteeId: null,
    formIsOpen: false,
    filtered: false,
    guaranteesCount: 0,
    newAmount: null,
    syncFlag: '10',
    guaranteeViewId: null,
    auctionId: '-1',
    toggleLetter: false,
    ...defaultControls,
  },
  paymentView: {
    controls: {
      doQuery: true,
      paymentsCount: 0,
      expandedUserId: null,
      activeOnly: true,
      showDetails: false,
      anchorEl: null,
      guaranteeId: null,
      formIsOpen: false,
      filtered: false,
      payment: null,
      editedAmount: '',
      ...defaultPaymentControls,
    },
    ids: {
      payments: [],
    },
    error: false,
    invalidControls: {},
  },
  filters: {
    activeOnly: false,
    groupByUser: false,
    minAmount: null,
    maxAmount: null,
    minConstitution: null,
    maxConstitution: null,
    minDate: null,
    maxDate: tomorrow.toISOString(),
    userSearch: '',
    status: '-1',
    paymentState: '-1',
    paymentType: '-1',
    guaranteeSort: 'date-dsc',
    auctionTypes: '-1',
    ids: [],
    hidePastAuctions: false,
  },
  pagination: {
    page: 0,
    count: 10,
  },
  error: false,
  invalidControls: defaultInvalidControls,
};

const guaranteesUnification = createReducer(initialState, {
  [SET_EXPANDED_USER_ID](state, action) {
    state.controls.expandedUserId = action.id ?? null;
  },
  [GUARANTEES_UNIFICATION.RESET](state) {
    state.controls = initialState.controls;
    state.filters = initialState.filters;
    state.pagination = initialState.pagination;
    state.error = initialState.error;
  },
  [GUARANTEES_UNIFICATION.INITIAL_QUERY](state) {
    state.controls.doQuery = false;
  },
  [GUARANTEES_UNIFICATION.INITIAL_QUERY_SUCCESS](state, action) {
    state.filters.ids = action.payload.ids.guarantees;
    state.controls.guaranteesCount = action.payload.controls.guaranteesCount;
    state.controls.doQuery = false;
  },
  [PAGINATION_CHANGED](state, action) {
    if (action.options.page) {
      state.pagination.page = action.options.page;
    }
    if (action.options.count) {
      state.pagination.count = action.options.count;
    }
  },
  [TOGGLE_DETAILS](state, action) {
    state.controls.showDetails = !state.controls.showDetails;
    state.controls.guaranteeViewId = action.guarantee?.id || null;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.controls.formIsOpen = false;
  },
  [APPLY_FILTER](state) {
    state.pagination.page = 0;
    state.controls.doQuery = true;
  },
  [CLEAR_FILTER](state) {
    state.filters = initialState.filters;
    state.pagination = initialState.pagination;
    state.controls.doQuery = true;
  },
  [GUARANTEES_UNIFICATION.CHANGE_AMOUNT](state) {
    state.controls.newAmount = null;
  },
  [GUARANTEES_UNIFICATION.SET_FLAG](state) {
    state.controls.syncFlag = '10';
  },
  [CONTROLS_CHANGED](state, action) {
    state.controls = { ...state.controls, ...action.controls };
    state.invalidControls = { ...state.invalidControls, ...(action.invalidControls || {}) };
  },
  [FILTERS_CHANGED](state, action) {
    state.filters = { ...state.filters, ...action.filters };
  },
  [SET_IDS](state, action) {
    state.filters.ids = action.ids;
  },
  [TOGGLE_LETTER](state) {
    state.controls.toggleLetter = !state.controls.toggleLetter;
  },
  // Bulk refund modal
  [SHOW_BULK_REFUND_MODAL](state) {
    state.controls.showBulkRefundModal = true;
  },
  [HIDE_BULK_REFUND_MODAL](state) {
    state.controls.showBulkRefundModal = false;
  },
  [TOGGLE_BULK_REFUND_MODAL](state) {
    state.controls.showBulkRefundModal = !state.controls.showBulkRefundModalrue;
  },

  [PAYMENT_CONTROLS_CHANGED](state, action) {
    state.paymentView.controls = { ...state.paymentView.controls, ...action.controls };
    state.paymentView.invalidControls = {
      ...state.paymentView.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [GUARANTEES_UNIFICATION.ACCEPT_RECEIPT](state) {
    state.paymentView.controls = { ...state.paymentView.controls, ...defaultControls };
  },
  [GUARANTEES_UNIFICATION.REJECT_RECEIPT](state) {
    state.paymentView.controls = { ...state.paymentView.controls, ...defaultControls };
  },
  [GUARANTEES_UNIFICATION.ENABLE_PAYMENT](state) {
    state.controls.showDetails = !state.controls.showDetails;
  },
  [GUARANTEES_UNIFICATION.DISABLE_PAYMENT](state) {
    state.controls.showDetails = !state.controls.showDetails;
  },
  [GUARANTEES_UNIFICATION.REJECT_PAYMENT](state) {
    state.controls.showDetails = !state.controls.showDetails;
  },
  [SHOW_GUARANTEE_SELECTION](state, actions) {
    state.paymentView.controls.guaranteeId = null;
    state.paymentView.controls.showGuaranteeSelection = actions.show;
  },
  [SET_GUARANTEE](state, action) {
    state.paymentView.controls.paymentGuaranteeId = action.value;
  },
  [GUARANTEES_UNIFICATION.DO_NOTHING](state, action) {},
});

export default guaranteesUnification;
